const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
// =============================================
// Account Dropdown Menu
// =============================================

function initAccountDropdown(isLoggedIn = false) {
  // const accountIcon = document.querySelector('sticky-header .header__icon--account') 
  //   || document.querySelector('.header__icon--account');
  // if (!accountIcon) return;
  const accountIcon = 
    document.querySelector('sticky-header .header__icon--account') ||
    document.querySelector('.header__icon--account') ||
    document.querySelector('.account-page-icon');

 const rawHref = accountIcon.getAttribute('href') || '/account';
 const accountBaseUrl = rawHref.includes('?') ? rawHref.split('?')[0] : rawHref;
 const accountQueryParams = rawHref.includes('?') ? '?' + rawHref.split('?')[1] : '';

  // Wrap the icon
  const wrapper = document.createElement('div');
  wrapper.className = 'account-dropdown-wrapper';
  accountIcon.parentNode.insertBefore(wrapper, accountIcon);
  wrapper.appendChild(accountIcon);

  // Build dropdown HTML
  const dropdown = document.createElement('div');
  dropdown.className = 'account-dropdown-menu';
  dropdown.setAttribute('role', 'menu');
  dropdown.setAttribute('aria-label', 'Account menu');

  if (isLoggedIn) {
    dropdown.innerHTML = `
      <div class="account-dropdown__section">
        <a href="${accountBaseUrl}/profile${accountQueryParams}" class="account-dropdown__item" role="menuitem">
          <svg class="account-dropdown__item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
          </svg>
          Profile
        </a>
        <a href="${accountBaseUrl}/orders${accountQueryParams}" class="account-dropdown__item" role="menuitem">
          <svg class="account-dropdown__item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/>
          </svg>
          Orders
        </a>
        <a href="${accountBaseUrl}/settings${accountQueryParams}" class="account-dropdown__item" role="menuitem">
          <svg class="account-dropdown__item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
          </svg>
          Settings
        </a>
      </div>
      <div class="account-dropdown__section">
         <a href="/account/logout" class="account-dropdown__item account-dropdown__item--signout" role="menuitem">
          <svg class="account-dropdown__item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
          Sign Out
        </a>
      </div>
    `;
  } else {
    dropdown.innerHTML = `
      <div class="account-dropdown__section">
        <div class="account-dropdown__guest-header">
          <p class="account-dropdown__guest-title">Welcome</p>
          <p class="account-dropdown__guest-subtitle">Sign in to view your account</p>
        </div>
        <a href="/account/login" class="account-dropdown__login-btn">Sign In</a>
      </div>
      
    `;
  }

  wrapper.appendChild(dropdown);

  // ---- Toggle logic ----
  let hoverIntent = null;

  function openDropdown() {
    dropdown.classList.add('is-open');
    accountIcon.classList.add('dropdown-active');
    accountIcon.setAttribute('aria-expanded', 'true');
  }

  function closeDropdown() {
    dropdown.classList.remove('is-open');
    accountIcon.classList.remove('dropdown-active');
    accountIcon.setAttribute('aria-expanded', 'false');
  }

  function isOpen() {
    return dropdown.classList.contains('is-open');
  }

  // Click toggle
  accountIcon.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    isOpen() ? closeDropdown() : openDropdown();
  });

  // Hover open
  wrapper.addEventListener('mouseenter', function () {
    clearTimeout(hoverIntent);
    openDropdown();
  });

  // Hover close
  wrapper.addEventListener('mouseleave', function () {
    hoverIntent = setTimeout(closeDropdown, 150);
  });

  // Close on outside click
  document.addEventListener('click', function (e) {
    if (!wrapper.contains(e.target)) {
      closeDropdown();
    }
  });

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) {
      closeDropdown();
      accountIcon.focus();
    }
  });

  // Keyboard nav within dropdown
  dropdown.addEventListener('keydown', function (e) {
    const items = Array.from(dropdown.querySelectorAll('.account-dropdown__item, .account-dropdown__login-btn'));
    const focused = document.activeElement;
    const idx = items.indexOf(focused);

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      items[(idx + 1) % items.length]?.focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      items[(idx - 1 + items.length) % items.length]?.focus();
    }
  });
}
// =============================================
// Custom Sort By Dropdown
// =============================================

function initCustomSelects() {
  document.querySelectorAll('.select__select').forEach(select => {
    if (select.parentElement.querySelector('.custom-select-wrapper')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'custom-select-wrapper';

    const trigger = document.createElement('div');
    trigger.className = 'custom-select-trigger';

    const selectedOption = select.options[select.selectedIndex];
    trigger.innerHTML = `
      <span>${selectedOption ? selectedOption.text : ''}</span>
      <svg class="icon icon-caret" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    `;

    const optionsList = document.createElement('div');
    optionsList.className = 'custom-select-options';

    Array.from(select.options).forEach((option, index) => {
      const div = document.createElement('div');
      div.className = 'custom-select-option' + (index === select.selectedIndex ? ' is-selected' : '');
      div.textContent = option.text;
      div.dataset.value = option.value;

      div.addEventListener('click', () => {
  select.value = option.value;
  select.dispatchEvent(new Event('change', { bubbles: true }));
  trigger.querySelector('span').textContent = option.text;
  optionsList.querySelectorAll('.custom-select-option').forEach(o => o.classList.remove('is-selected'));
  div.classList.add('is-selected');
  wrapper.classList.remove('is-open');
  const form = select.closest('form');
  if (form) {
    form.dispatchEvent(new Event('input', { bubbles: true }));
    form.submit();
  }
});

      optionsList.appendChild(div);
    });

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      wrapper.classList.toggle('is-open');
    });

    document.addEventListener('click', () => wrapper.classList.remove('is-open'));

    wrapper.appendChild(trigger);
    wrapper.appendChild(optionsList);
    select.parentElement.insertBefore(wrapper, select);
  });
}

window.addEventListener('load', () => {
  initCustomSelects();
});